import MarketplaceInfo from './MarketplaceInfo';

export default MarketplaceInfo;
